import React from "react";

function WhatsAppIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 33 34"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3.347 30.27l1.852-6.76a13.022 13.022 0 01-1.743-6.524C3.459 9.79 9.314 3.937 16.51 3.937a12.971 12.971 0 019.233 3.827 12.97 12.97 0 013.82 9.232c-.003 7.195-5.86 13.049-13.053 13.049-.001 0 0 0 0 0h-.006c-2.184-.001-4.331-.549-6.238-1.59l-6.92 1.816z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3.346 30.615a.343.343 0 01-.331-.434l1.814-6.625a13.392 13.392 0 01-1.716-6.57C3.115 9.601 9.125 3.594 16.509 3.594a13.315 13.315 0 019.477 3.927 13.311 13.311 0 013.92 9.475c-.003 7.384-6.013 13.392-13.397 13.392a13.43 13.43 0 01-6.286-1.565l-6.79 1.78a.316.316 0 01-.087.012z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#CFD8DC"
        fillRule="evenodd"
        d="M16.51 3.938a12.971 12.971 0 019.233 3.826 12.97 12.97 0 013.82 9.232c-.003 7.195-5.86 13.049-13.053 13.049h-.006c-2.184-.001-4.33-.549-6.237-1.59l-6.92 1.816 1.852-6.762a13.022 13.022 0 01-1.743-6.523C3.46 9.79 9.314 3.937 16.51 3.937zm0-.688c-7.574 0-13.738 6.161-13.741 13.736 0 2.314.583 4.595 1.692 6.615L2.684 30.09a.686.686 0 00.838.846l6.66-1.746a13.769 13.769 0 006.322 1.543c7.58 0 13.743-6.162 13.747-13.736a13.651 13.651 0 00-4.02-9.718A13.66 13.66 0 0016.51 3.25z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#40C351"
        fillRule="evenodd"
        d="M24.183 9.322a10.776 10.776 0 00-7.67-3.18c-5.984 0-10.851 4.864-10.854 10.844 0 2.05.573 4.045 1.66 5.773l.258.41L6.48 27.17l4.106-1.077.397.235a10.829 10.829 0 005.522 1.512h.004c5.98 0 10.847-4.865 10.85-10.846a10.78 10.78 0 00-3.176-7.673z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.247 11.531c-.244-.543-.501-.554-.735-.564-.19-.008-.407-.007-.624-.007a1.2 1.2 0 00-.87.408c-.3.327-1.142 1.115-1.142 2.72 0 1.604 1.169 3.155 1.332 3.373.163.217 2.256 3.615 5.571 4.923 2.755 1.086 3.316.87 3.914.816.598-.054 1.93-.789 2.201-1.55.272-.762.272-1.415.19-1.55-.08-.137-.298-.218-.624-.382-.326-.163-1.93-.952-2.229-1.06-.299-.109-.516-.163-.734.163-.217.326-.842 1.061-1.033 1.278-.19.218-.38.246-.706.082-.326-.164-1.377-.507-2.623-1.618-.97-.864-1.624-1.932-1.815-2.259-.19-.326-.02-.502.143-.665.147-.147.326-.381.49-.571.163-.191.217-.327.326-.544.108-.218.054-.409-.028-.572-.08-.163-.714-1.776-1.004-2.421z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default WhatsAppIcon;
